import { Permission } from '@/lib/permissions/v1'

export default {
    path: '/reports',
    component: () => import('@/views/Index.vue'),
    name: 'reports',
    meta: {
        label: 'Reports',
        auth: true,
        location: 'sidebar-top',
        icon: 'fal fa-file-chart-line fa-fw',
        permission: 'manage-reports',
        group: 'main',
        children: true,
    },
    children: [
        {
            path: 'glance',
            name: 'reports.glance.index',
            component: () => import('@/views/report/glance/Index.vue'),
            meta: {
                label: 'At a glance',
                auth: true,
                permission: 'manage-reports',
                icon: 'fal fa-file-chart-line fa-fw',
                location: 'sidebar',
                parent: 'reports',
            },
        },
        {
            path: 'customers',
            name: 'reports.customers.index',
            component: () => import('@/views/report/customers/Index.vue'),
            meta: {
                label: 'All Customers',
                auth: true,
                permission: 'manage-reports',
                icon: 'fal fa-file-chart-line fa-fw',
                location: 'sidebar',
                parent: 'reports',
            },
        },
        {
            path: 'rates',
            name: 'reports.rates.index',
            component: () => import('@/views/report/rates/Index.vue'),
            meta: {
                label: 'Rates',
                auth: true,
                permission: 'manage-reports',
                icon: 'fal fa-file-chart-line fa-fw',
                location: 'sidebar',
                parent: 'reports',
            },
        },
        {
            path: 'billing-excluded',
            name: 'reports.billing-excluded.index',
            component: () => import('@/views/report/billing-excluded/Index.vue'),
            meta: {
                label: 'Billing Excluded',
                auth: true,
                permission: 'manage-reports',
                icon: 'fal fa-file-chart-line fa-fw',
                location: 'sidebar',
                parent: 'reports',
            },
        },
        {
            path: 'invoices',
            name: 'reports.invoices.index',
            component: () => import('@/views/report/invoices/Index.vue'),
            meta: {
                label: 'Invoices',
                auth: true,
                permission: Permission.InvoiceViewAny,
                icon: 'fal fa-file-chart-line fa-fw',
                location: 'sidebar',
                parent: 'reports',
            },
        },
    ],
}
